$(function () {
    $("form .submit-btn").click(function (e) {

        var isValid = true;

        $(".has-required input[type=text], .has-required select, .has-required textarea")
            .each(function(index, element) {
                var labelEl = $(element).parent('.has-required').find('label');
                labelEl.find('.err-msg').remove();
                if (_.isEmpty($(element).val())) {
                    labelEl.append('<span class="err-msg">必須項目です。</span>');
                    isValid = false;
                }
            });

        $(".has-required")
            .each(function (index, element) {
                if ($(element).find("input[type=checkbox]").length > 0) {
                    var labelEl = $(element).find('label').first();
                    labelEl.find('.err-msg').remove();

                    var checkBoxValues = [];
                    $(element).find("input[type=checkbox]:checked").each(function (i, el) {
                        checkBoxValues[i] = $(el).val();
                    });

                    if (_.isEmpty(checkBoxValues)) {
                        labelEl.append('<span class="err-msg">必須項目です。</span>');
                        isValid = false;
                    }
                }
            })

        if (isValid) {
            $($(this).data('target')).modal('show');
        }
    });
});
